import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import { useAssetLookup } from "../api/useAssetLookup";
import { AssetIcon } from "../components/AssetIcon";
import { AssetList } from "./AssetList";
import { FindingCard } from "./FindingCard";
import type { FindingProps } from "./FindingProps";
import { iconSize } from "./iconSize";

const TITLE = msg({
  id: "finding.core_items_on_time",
  message: "{count, plural, one {# core item} other {# core items}} on time",
});

const DETAILS = msg({
  id: "finding.core_items_on_time.details",
  message: "Bought no later than strong players on this hero.",
});

// Сильная сторона: ключевые предметы куплены вовремя.
export const CoreItemsOnTime = ({ finding, variant }: FindingProps<"core_items_on_time">) => {
  const { i18n } = useLingui();
  const findItem = useAssetLookup("items");
  const ids = finding.params.item_ids;
  const details = i18n._(DETAILS);
  return (
    <FindingCard
      code={finding.code}
      severity={finding.severity}
      variant={variant}
      icon={<AssetIcon asset={findItem(ids[0] ?? 0)} size={iconSize(variant)} />}
      title={i18n._({ ...TITLE, values: { count: ids.length } })}
      details={details}
      summary={details}
    >
      <AssetList entries={ids.map((id) => ({ asset: findItem(id) }))} />
    </FindingCard>
  );
};
